import { render, staticRenderFns } from "./RiskLevelDataBase.vue?vue&type=template&id=2694b4f9&scoped=true&"
import script from "./RiskLevelDataBase.vue?vue&type=script&lang=js&"
export * from "./RiskLevelDataBase.vue?vue&type=script&lang=js&"
import style0 from "./RiskLevelDataBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RiskLevelDataBase.vue?vue&type=style&index=1&id=2694b4f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694b4f9",
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/RiskLevelDataBase.vue"
export default component.exports